'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const ClientAboutUsComponent = dynamic(() => import('./ClientAboutUsComponent'), { ssr: false });

export default function AboutClientWrapper() {
  return <ClientAboutUsComponent />;
}
